// extracted by mini-css-extract-plugin
export default {"root":"mimic___style_root__I6L7A","text":"mimic___style_text__EFNLU","sm":"mimic___style_sm__BCWFd","md":"mimic___style_md__Zc17t","lg":"mimic___style_lg__wkiwy"};